import React from 'react';

// Conversion funnel rendered with plain div bars: each stage shows its count,
// % of the first stage, and drop-off vs the previous stage.
const FunnelBars = ({ funnel }) => {
  const stages = funnel || [];
  if (stages.length === 0) return <div className="no-data">No funnel data</div>;

  const max = Math.max(1, ...stages.map((s) => s.count || 0));
  const first = stages[0]?.count || 0;

  return (
    <div className="funnel-bars">
      {stages.map((stage, i) => {
        const prev = i > 0 ? stages[i - 1].count || 0 : null;
        const pctOfFirst = first > 0 ? ((stage.count / first) * 100) : 0;
        const conversion = prev !== null && prev > 0 ? ((stage.count / prev) * 100) : null;
        return (
          <div key={stage.stage} className="funnel-row">
            <div className="funnel-label">
              <span>{stage.stage}</span>
              <span className="funnel-count">{stage.count}</span>
            </div>
            <div className="funnel-track">
              <div
                className="funnel-fill"
                style={{ width: `${Math.max(1.5, (stage.count / max) * 100)}%` }}
              />
            </div>
            <div className="funnel-meta">
              <span>{first > 0 ? `${pctOfFirst.toFixed(1)}% of top` : '-'}</span>
              {conversion !== null && (
                <span className={conversion < 50 ? 'funnel-drop' : 'funnel-keep'}>
                  {conversion.toFixed(1)}% from previous
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelBars;
